module.exports = __webpack_public_path__ + "static/media/bg.9aca3bed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/backgrounds/bg.svg
// module id = 1494
// module chunks = 37